export const DEAL_STATUS_FILTER_KEY = 'stage';
export const LISTING_STATUS_FILTER_KEY = 'listingStage';
export const LISTING_TYPE_FILTER_KEY = 'listingType';

// price filters
export const DEAL_FROM_FILTER_KEY = 'from';
export const DEAL_TO_FILTER_KEY = 'to';

export const DEAL_INDUSTRY_FILTER_KEY = 'industry';

export const DEAL_LOCATION_FILTER_KEY = 'location';

export const ENTERPRISE_BUSINESS_UNIT = 'enterpriseBusinessUnitId';

export const USER_ID = 'userId';

export const COLLEAGUE_ID = 'colleagueIds';

export const ENTERPRISE_ENTITY_ID = 'enterpriseEntityId';

export const VIEW_AS_USER = 'viewAsUserId';
export const VIEW_AS_NAME = 'viewAsUserName';

export const TIMEFRAME_FILTER = 'timeframe';
